import { Component, ElementRef, Input, OnChanges, OnInit } from '@angular/core';
import { MessagePageService } from '@app/core/private/messagepage/services/messagepage.service';
import { LoadingService } from '@app/core/shared';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { HubPageService } from '../../services/hub-page.service';

@UntilDestroy()
@Component({
  selector: 'app-custom-message-page-banner',
  templateUrl: './custom-message-page-banner.component.html',
  styleUrls: ['./custom-message-page-banner.component.scss']
})
export class CustomMessagePageBannerComponent implements OnChanges {
  @Input() componentId: string;
  @Input() payload: any;
  @Input() culture: string;

  message: any;
  data: any;
    public slideConfigHub: any = {
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 10000,
        pauseOnDotsHover: false,
        pauseOnFocus: true,
        pauseOnHover: true,
        cssEase: 'ease',
        easing: 'linear',

    };
  constructor(
    private hubPageService: HubPageService,
    private messagePageService: MessagePageService,
    public loadingService: LoadingService,
    private elementRef: ElementRef,
  ) { }

    ngOnChanges() {
    let data = { item: JSON.stringify(this.payload) };
    this.loadingService
      .doLoading(
        this.hubPageService.getHubComponent(
          this.componentId,
          this.culture,
          data
        ),
        this,
        "message"
      )
      .pipe(untilDestroyed(this))
      .subscribe((response) => {
        this.message = response;
        var res = response.articles.sort((a,b) => (a.articleDate > b.articleDate) ? -1 : ((b.articleDate > a.articleDate) ? 1 : 0));
        console.log('This Message', this.message)
      });
  }

  getArticle(articleId: any) {
    this.messagePageService
      .getArticle(this.message.id, "en-GB", articleId)
      .subscribe((data) => {
        this.data = data.fullText;
        let parser = new DOMParser();
        let doc = parser.parseFromString(data.fullText, "text/html");
        if (
          doc.getElementsByClassName("messageArticle") &&
          doc.getElementsByClassName("messageArticle").length
        ) {
          // window.location.href = "/messagearticle/" + promoid;
          window.location.href = `/messagearticle/${this.message.id}/view/${articleId}`;
        }
        if (
          doc.getElementsByClassName("customHyperLink") &&
          doc.getElementsByClassName("customHyperLink").length
        ) {
          let customLink = doc
            .getElementsByClassName("customHyperLink")[0]
            .innerHTML.toString();
          window.location.href = customLink;
        }
      });
  }

}
